/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S4_P2_PreInputs */

const tr_iade_iptal_s4_p2_pre = /** @type {(inputs: Iade_Iptal_S4_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel her satın alma sırasında Abone'ye`)
};

const en_iade_iptal_s4_p2_pre = /** @type {(inputs: Iade_Iptal_S4_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At each purchase ShopPanel presents the Subscriber with a separate consent checkbox containing the statement`)
};

const de_iade_iptal_s4_p2_pre = /** @type {(inputs: Iade_Iptal_S4_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel legt dem Abonnenten bei jedem Kauf ein gesondertes Ankreuzfeld vor, das die Erklärung`)
};

const ru_iade_iptal_s4_p2_pre = /** @type {(inputs: Iade_Iptal_S4_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При каждой покупке ShopPanel предоставляет Абоненту отдельное поле подтверждения, содержащее заявление`)
};

/**
* | output |
* | --- |
* | "At each purchase ShopPanel presents the Subscriber with a separate consent checkbox containing the statement" |
*
* @param {Iade_Iptal_S4_P2_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s4_p2_pre = /** @type {((inputs?: Iade_Iptal_S4_P2_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S4_P2_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s4_p2_pre(inputs)
	if (locale === "de") return de_iade_iptal_s4_p2_pre(inputs)
	if (locale === "ru") return ru_iade_iptal_s4_p2_pre(inputs)
	return tr_iade_iptal_s4_p2_pre(inputs)
});